import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CHANGE_CURRENT_PAGE_NUMBER,
  PDF_CLEAR_ALL_STATE,
} from '@app/libs/reactPdfJs/store/actionTypes';

type PdfCurrentPageNumberState = number;

const initialState: PdfCurrentPageNumberState = 1;

export default function reducer(
  state: PdfCurrentPageNumberState = initialState,
  action: PdfAction
) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return 1;
    case PDF_CHANGE_CURRENT_PAGE_NUMBER:
      return action.payload;
    default:
      return state;
  }
}
